"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const Radio_1 = __importDefault(require("@Components/Radio"));
const RepresentativeDetails = (props) => {
    const { setRepresentation } = props;
    const setRepresentationOption = (data) => {
        setRepresentation(data.id);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'representation-container' },
            react_1.default.createElement("h5", { className: 'medium subtitle' }, "You should only create a publisher if you administer the shares for that entity."),
            react_1.default.createElement("h5", { className: 'medium subtitle' }, "Do you administer the shares for the entity you wish to create?"),
            react_1.default.createElement(Radio_1.default, { field: { name: 'representation' }, options: [
                    { id: 1, value: 'yes', label: 'Yes, I administer the shares for this entity' },
                    {
                        id: 2,
                        value: 'no',
                        label: 'No, I do not administer the shares.',
                    },
                ], onChange: setRepresentationOption, defaultCheckedId: 1 }))));
};
exports.default = (0, mobx_react_1.observer)(RepresentativeDetails);
